// extracted by mini-css-extract-plugin
export default {"root":"N5zCSdq3PLBvcRLdSlp6","placeHolderShimmer":"R6s9J0eXrGCLtEOTdQFn"};